import { content } from './content';
export default {
  dpn: {
    id: 'familydollar',
    name: 'Family Dollar',
  },
  storageKey: 'pbyt',
  mpid: {
    production: process.env.REACT_APP_MPID,
    local: '',
  },
  token: '', //captcha token
  images: {
    logo: 'familydollar-logo.png',
  },
  links: {
    register: 'https://www.familydollar.com/create-account?screenToRender=traditionalRegistratio',
  },
  content: content,
};
